/**
 * Send a Klaviyo metric event using the new proxy based API.
 *
 * @param {string} event - Klaviyo metric name
 * @param {Record<string, any>} [payload]
 */
export function trackKlaviyo(event, payload = {}) {
	if (typeof window === 'undefined') return;
	window.klaviyo?.track(event, payload);
}

export const trackSubscribedToList = (payload = {}) => trackKlaviyo('Subscribed to List', payload);
export const trackViewedProduct = (payload = {}) => trackKlaviyo('Viewed Product', payload);
export const trackActiveOnSite = (payload = {}) => trackKlaviyo('Active on Site', payload);
export const trackAddedToCart = (payload = {}) => trackKlaviyo('Added to Cart', payload);
export const trackAddedToCartFirstOrder = (payload = {}) =>
	trackKlaviyo('Added to Cart - First Order', payload);
export const trackStartedCheckout = (payload = {}) => trackKlaviyo('Started Checkout', payload);
export const trackPlacedOrder = (payload = {}) => trackKlaviyo('Placed Order', payload);
export const trackFulfilledOrder = (payload = {}) => trackKlaviyo('Fulfilled Order', payload);
export const trackUsedPoints = (payload = {}) => trackKlaviyo('Used Points', payload);
export const trackEnteredCompetition = (payload = {}) =>
	trackKlaviyo('Entered Competition', payload);
export const trackWonCompetition = (payload = {}) => trackKlaviyo('Won Competition', payload);
export const trackInstantWinTriggered = (payload = {}) =>
	trackKlaviyo('Instant Win Triggered', payload);

export const trackViewedItem = (payload = {}) => {
	if (typeof window !== 'undefined' && window.klaviyo?.trackViewedItem) {
		window.klaviyo.trackViewedItem(payload);
	}
};

export const trackViewedCategory = (payload = {}) => trackKlaviyo('Viewed Category', payload);

// Subscription intent without completing checkout
export const trackSubscribeClickedNoCheckout = (payload = {}) =>
       trackKlaviyo('Subscribe Clicked - No Checkout', payload);

// Existing subscriber clicked upgrade but didn't complete checkout
export const trackSubscribeClickedUpgradeNoCheckout = (payload = {}) =>
       trackKlaviyo('Subscribe Clicked Upgrade - No Checkout', payload);

// Existing subscriber clicked downgrade/cancel but didn't complete
export const trackSubscribeClickedDowngradeNoCheckout = (payload = {}) =>
       trackKlaviyo('Subscribe Clicked Downgrade - No Checkout', payload);

// A subscriber cancelled their plan
export const trackSubscriberCancelled = (payload = {}) =>
       trackKlaviyo('Subscriber Cancelled', payload);

// Previous subscriber visiting without an active subscription
export const trackSubscriberRecapture = (payload = {}) =>
       trackKlaviyo('Subscriber Re Capture', payload);

// After checkout encourage referral sign up for new users
export const trackNewUserPostCheckoutReferral = (payload = {}) =>
       trackKlaviyo('New User Post Checkout Push Referral', payload);

// After checkout encourage referral sign up for existing users
export const trackExistingUserPostCheckoutReferral = (payload = {}) =>
       trackKlaviyo('Existing User Post Checkout Push Referral', payload);

// Customer is granted a referral bonus
export const trackReferralBonusGranted = (payload = {}) =>
       trackKlaviyo('Referral Bonus Granted', payload);

// Users previously referred but not recently active
export const trackReferralRecapture = (payload = {}) =>
       trackKlaviyo('Referral Re Capture', payload);

// Every Ticket Wins promotion tracker event
export const trackEveryTicketWinsTracker = (payload = {}) =>
       trackKlaviyo('Every Ticket Wins - Tracker', payload);

// Notification that a prize shipment is on the way
export const trackPrizeOnItsWay = (payload = {}) =>
       trackKlaviyo('Prize On Its Way!', payload);
